<script lang="ts" setup>
import { Co2QuizQuestion } from '@/models/co2-quiz.model';
import { PropType } from 'vue';
import { Category } from '@/models/category.model';

defineProps({
  data: {
    type: Object as PropType<{
      questions: Co2QuizQuestion[];
      categories: Category[];
    }>,
    required: true,
  },
});

function getQuestionAndCategories(
  categories: Category[],
  questions: Co2QuizQuestion[],
  parentCategoryId: number | null,
): { category: Category; questions: Co2QuizQuestion[] }[] {
  return [...categories]
    .filter((c) =>
      parentCategoryId
        ? c.parentCategory?.id === parentCategoryId
        : !c.parentCategory,
    )
    .sort((a, b) => a.index - b.index)
    .map((category) => {
      return {
        category,
        questions: questions.filter((q) =>
          q.categories.map((c) => c.id).includes(category.id),
        ),
      };
    });
  // .filter((v) => v.questions.length);
}
</script>
<template>
  <v-container>
    <h2>Co2 quiz overview</h2>

    <v-container>
      <ul>
        <li
          v-for="cat in getQuestionAndCategories(
            data.categories,
            data.questions,
            null,
          )"
          :key="cat.category.id"
        >
          <div>
            <strong> {{ cat.category.title }}</strong>
            <v-card v-if="cat.questions.length" elevation="4" class="">
              <v-card-text>
                <p v-for="q in cat.questions" :key="q.id">{{ q.title }}</p>
              </v-card-text>
            </v-card>
          </div>
          <ul class="ml-4">
            <li
              v-for="cat2 in getQuestionAndCategories(
                data.categories,
                data.questions,
                cat.category.id,
              )"
              :key="cat2.category.id"
            >
              <strong> {{ cat2.category.title }}</strong>
              <v-card v-if="cat2.questions.length" elevation="4" class="">
                <v-card-text>
                  <p v-for="q in cat2.questions" :key="q.id">{{ q.title }}</p>
                </v-card-text>
              </v-card>
              <ul class="ml-4">
                <li
                  v-for="cat3 in getQuestionAndCategories(
                    data.categories,
                    data.questions,
                    cat2.category.id,
                  )"
                  :key="cat3.category.id"
                >
                  <strong> {{ cat3.category.title }}</strong>
                  <v-card v-if="cat3.questions.length" elevation="4" class="">
                    <v-card-text>
                      <p v-for="q in cat3.questions" :key="q.id">
                        {{ q.title }}
                      </p>
                    </v-card-text>
                  </v-card>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </v-container>
  </v-container>
</template>
